const translations = {
    en: {
        news: {
            category_explorer: {
                categories: "CATEGORIES"
            }
        }
    },
    de: {
        news: {
            category_explorer: {
                categories: "KATEGORIE"
            }
        }
    },
    es: {
        news: {
            category_explorer: {
                categories: "Categorías"
            }
        }
    },
    fr: {
        news: {
            category_explorer: {
                categories: "CATÉGORIES"
            }
        }
    },
    it: {
        news: {
            category_explorer: {
                categories: "CATEGORIE"  
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/news/NewsCategoryExplorer.js